<template>
  <v-app>
        
    <default-view />

    <default-footer />

    <!-- Menu rechts Einstellungen -->
    <!-- <default-settings /> -->
  </v-app>
</template>

<script>
  export default {
    name: 'DefaultLayout',

    components: {
    
      DefaultFooter: () => import(
        /* webpackChunkName: "default-footer" */
        './Footer'
      ),
      DefaultView: () => import(
        /* webpackChunkName: "default-view" */
        './View'
      ),    
    },
  }
</script>
